
import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { mapState } from 'vuex';

@Component({
  components: {},
  computed: {
    ...mapState(['availableStates']),
  },
})
export default class StateSelect extends Vue {
  @Prop({ type: Boolean, required: false }) public readonly disabled!: boolean;
  @Prop({ type: Boolean, required: false }) public readonly showInputText!: boolean;
  @Prop({ type: Array }) private readonly selectedStatesProp!: [];

  public availableStates!: string[];
  public selectedStates: string[] = [];

  public toggleAllStates(): void {
    if (this.selectedStates?.length === this.availableStates.length) {
      this.selectedStates = [];
    } else {
      this.selectedStates = [...this.availableStates];
    }
  }

  public get toggleAllStatesIcon(): string {
    if (this.selectedStates?.length === 0) {
      return 'mdi-checkbox-blank-outline';
    } else if (this.selectedStates?.length === this.availableStates.length) {
      return 'mdi-checkbox-marked';
    } else {
      return 'mdi-minus-box';
    }
  }

  @Watch('selectedStates')
  private setSelectedStates() {
    this.$emit('change', this.selectedStates);
  }

  @Watch('selectedStatesProp', { immediate: true, deep: true })
  private setSelectedStatesProp() {
    this.selectedStates = this.selectedStatesProp;
  }
}
